<template>
    <div>
        <div class="shadow_box rounded-lg p-6 relative flex flex-col">
            <p class="title"><strong>Pesquisa</strong></p>
            <form class="mt-1 w-full" @submit.prevent="reloadTable">
            <div class="flex flex-wrap mb-4 px-4">
                <text-input class="lg:pr-6 w-full lg:w-1/4" label="Nome" v-model="search.name"/>
                </div>
                <div class="flex flex-shrink-0 flex-wrap items-center justify-start p-4 rounded-b-md">
                <button class="btn-purple px-6 py-2.5 text-white font-roboto font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-gray-700 hover:shadow-lg focus:bg-gray-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-gray-800 active:shadow-lg transition duration-150 ease-in-out">
                    <font-awesome-icon icon="fa-magnifying-glass" class="text-white text-sm mr-0 lg:mr-2" />
                    Pesquisar
                </button>
                <button
                class="btn flex items-center text-purple-100 font-roboto font-medium
                px-6 py-2.5 text-xs leading-tight uppercase ml-1 border-solid border-2 border-purple-100" @click="clearSearch">
                    <font-awesome-icon icon="fa-eraser" class="text-purple text-sm mr-0 lg:mr-2" />
                    Limpar
                </button>
            </div>
        </form>
        </div>
        <Head title="Gerenciar Fornecedores" />
        <div class="shadow_box rounded-lg p-6 mt-4">
            <h1 class="mb-6 text-2xl text-gray-777 font-roboto uppercase">
                Gerenciar Marcas
            </h1>
            <div class="grid grid-cols-2">
                <div class="col-span-2 font-bold">
                    <span class="whitespace-nowrap overflow-hidden w-full">Rede:</span>
                </div>
                <div class="col-span-2">
                    <span class="whitespace-nowrap overflow-hidden w-full">{{ provider.name }}</span>
                </div>
                <div class="col-span-2 font-bold">
                    <span class="whitespace-nowrap overflow-hidden">Unidade:</span>
                </div>
                <div class="col-span-2">
                    <span class="whitespace-nowrap overflow-hidden">{{ market.address }}</span>
                </div>
                <br>
            </div>
            <data-table 
                v-if="loadTable" 
                v-model:columns="columns" 
                :route="'/provider_brand/list/' + provider.id + '/'+market.id"
                :query="getQuery( search, 'search2' )"
                no-data-label="Nenhuma rede cadastrada" no-result-label="Nenhuma rede encontrada">
                    <template #table.cell.content.market="{ value, row }">
                        <div class="place-self-center grid-cols-2 gap-4">
                            <span class="flex items-center justify-center text-sm">
                                <Link :href="'market/' + row.id" class="rounded p-2 bg-purple-100 text-white">
                                Ver Lojas<font-awesome-icon icon="fa-solid fa-angle-right" class="pl-2" />
                                </Link>
                            </span>
                        </div>
                    </template>
                    <template #table.cell.content.product="{ value, row }">
                        <div class="place-self-center grid-cols-2 gap-4">
                            <span class="flex items-center justify-center text-sm">
                                <button class="rounded p-2 bg-purple-100 text-white" @click.prevent="openModalConfig(row)">
                                    Ver Produtos
                                    <font-awesome-icon icon="fa-solid fa-angle-right" class="pl-2" />
                                </button>
                            </span>
                        </div>
                    </template>
                    <template #table.cell.content.actions="{ value, row }">
                        <div class="inline-grid grid-cols-2 gap-4 ">
                            <span @click="openModalEdit(row)" class="bg-purple-200 text-white rounded p-2 cursor-pointer text-sm">
                            <font-awesome-icon icon="fa-pencil" class="text-white pr-2" />Editar
                            </span>
                            <span @click="openModalConfirmDelete(row)"
                                class="bg-red_delete text-white rounded p-2 cursor-pointer text-sm">
                                <font-awesome-icon icon="fa-trash-can" class="text-white pr-2" />Excluir
                            </span>
                        </div>
                    </template>

                    <template #grid.content.body.product="{ value, row }">
                        <div class="place-self-center grid-cols-2 gap-4">
                            <span class="flex items-center justify-center text-sm">
                                <button class="rounded p-2 bg-purple-100 text-white" @click.prevent="openModalConfig(row)">
                                    Ver Produtos
                                    <font-awesome-icon icon="fa-solid fa-angle-right" class="pl-2" />
                                </button>
                            </span>
                        </div>
                    </template>

                    <template #grid.content.body.actions="{ value, row }">
                        <div class="inline-grid grid-cols-2 gap-4 ">
                            <span @click="openModalEdit(row)" class="bg-purple-200 text-white rounded p-2 cursor-pointer text-sm">
                            <font-awesome-icon icon="fa-pencil" class="text-white pr-2" />Editar
                            </span>
                            <span @click="openModalConfirmDelete(row)"
                                class="bg-red_delete text-white rounded p-2 cursor-pointer text-sm">
                                <font-awesome-icon icon="fa-trash-can" class="text-white text-lg pr-2" />Excluir
                            </span>
                        </div>
                    </template>

                    <template #after.reload-button>
                        <button class="flex items-end font-roboto font-medium btn-purple uppercase"
                            @click.prevent="openModalEdit({})">
                            <font-awesome-icon icon="fa-plus" class="text-white text-lg mr-0 lg:mr-2" /><span
                                class="hidden lg:block">
                                Adicionar Marca à Unidade</span>
                        </button>
                    </template>
            </data-table>
        </div>
        <modal-delete ref="modalDelete" @confirm="reloadTable"></modal-delete>

        <modal-edit ref="modalEdit" title="Marca" url="market_network_rules" @submitForm="reloadTable" id="modal-adicionar-regra">
            <template #form="{ item }">

                <select-input 
                    v-model="item.brand_id" 
                    :error="item.errors.brand_id"
                    class="lg:pr-6 w-full" 
                    label="Marca" 
                    @change="changeBrand($event)">
                        <option :value="null" />

                        <option v-for="(value, name, index) in brand_options" :key="name" :value="name">
                            {{ value }}
                        </option>
                </select-input>

                <select-input 
                    v-model="item.visiting_rules_id" 
                    :error="item.errors.visiting_rules_id" 
                    class="lg:pr-6 w-full"
                    label="Vincular regra" 
                    required="true">
                        <option :value="null" />

                        <option v-for="(value, name, index) in rules_options" :key="name" :value="name">
                            {{ value }}
                        </option>
                </select-input>

                <switch-input 
                    v-model="item.priority" 
                    class="w-full mt-6" 
                    label="Prioridade" labelChecked="Prioritário"
                    labelUnchecked="Não prioritário" />
                
                <date-input v-model="item.date_start" :error="item.errors.date_start" class="mt-6 lg:pr-6 w-full lg:w-1/2"
                    label="Data de Início" required="true" />

                <multi-select-input 
                    appendTo="#modal-adicionar-regra" 
                    v-model="item.products" 
                    :multiple="true"
                    :options="specialtiesOrdered" 
                    :error="item.errors.products" 
                    class="lg:pr-6 w-full mt-6"
                    label="Produtos" 
                    required="true">
                        <template v-slot="slotProps">
                            <div class="flex items-center gap-4">
                                <img 
                                    v-if="slotProps.option.url_image" 
                                    :src="slotProps.option.url_image" 
                                    class="w-32 rounded" />
                                
                                <p>
                                    {{ slotProps.option.label }} - {{ slotProps.option.bar_code }}
                                </p>
                            </div>
                        </template>

                </multi-select-input>
            </template>
        </modal-edit>

        <modal ref="modalConfig" size="modal-lg" :modal-scrollable="true" :modal-backdrop="true" id="modal-config">
            <template #header>
                <div class="text-gray-777 font-roboto uppercase">
                    <span>Ver produtos</span>
                </div>
            </template>

            <template #body>
                <table class="w-full">
                    <thead>
                        <tr class="bg-gray-100 font-roboto">
                            <th class="px-4 py-3">Imagem</th>
                            <th class="px-4 py-3">Produto</th>
                            <th class="px-4 py-3">Código de barras</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr v-for="( product, i ) in productModal" :key="i">
                            <td>
                                <img
                                    :src="product.url_image || '/images/product_placeholder.svg'"
                                    :alt="`imagem do produto ${ product.label }`"
                                    class="w-32 mx-auto rounded"
                                    @error="$event.target.src = '/images/product_placeholder.svg'" />
                            </td>

                            <td class="text-center">{{ product.label }}</td>
                            <td class="text-center">{{ product.bar_code }}</td>
                        </tr>
                    </tbody>
                </table>
            </template>

            <template #footer>
                <button type="button"
                    class="px-6 py-2.5 bg-gray-600 text-white font-roboto font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-gray-700 hover:shadow-lg focus:bg-gray-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-gray-800 active:shadow-lg transition duration-150 ease-in-out"
                    @click.prevent="closeModalConfig">Fechar</button>
            </template>
        </modal>
    </div>
</template>

<script>
import { Head, Link, useForm } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import LoadingButton from '@/Shared/LoadingButton'
import ModalDelete from '@/Shared/ModalDelete'
import ModalEdit from '@/Shared/ModalEdit'
import TextInput from '@/Shared/TextInput'
import DataTable from '@/Shared/DataTable'
import SelectInput from '@/Shared/SelectInput'
import Modal from '@/Shared/Modal'
import CheckGroup from '@/Shared/CheckGroup.vue'
import SwitchInput from '@/Shared/SwitchInput'
import DateInput from '@/Shared/DateInput'
import MultiSelectInput from '@/Shared/MultiSelectInput'

import { queryMixin } from '@/Mixins/Query'

export default {
    components: {
        Head,
        LoadingButton,
        ModalDelete,
        ModalEdit,
        TextInput,
        DataTable,
        SelectInput,
        Modal,
        CheckGroup,
        SwitchInput,
        DateInput,
        Link,
        MultiSelectInput,
    },
    props: {
        brand_options: Object,
        provider: Object,
        market: Object,
        market_network: String,
        rules_options: Object,
    },
    layout: Layout,
    mixins: [ queryMixin ],
    data() {
        return {
            loadModalConfig: false,
            loadTable: true,
            productsOptions: [],
            specialtiesOrdered: [],
            products: [],
            search: {
                name: '',
            },

            columnsProductTable: [
                {
                    uniqid: 'image',
                    label: 'Imagem',
                    field: 'url_image',
                    visible: true,
                    sortable: false,
                    sortOrder: 'asc',
                    classes: 'px-4 py-3 border-b text-sm',
                    headerClass: 'p-4 text-left',
                }
            ],

            columns: [
                {
                    uniqid: 'brand_name',
                    label: 'Nome da Marca',
                    field: 'brand_label',
                    visible: true,
                    sortable: false,
                    sortOrder: 'asc',
                    classes: 'px-4 py-3 border-b text-sm',
                    headerClass: 'p-4 text-left',
                },
                {
                    uniqid: 'date_start',
                    label: 'Data de Inicio',
                    field: 'date_start',
                    visible: true,
                    sortable: false,
                    sortOrder: 'asc',
                    classes: 'px-4 py-3 border-b text-sm',
                    headerClass: 'p-4 text-left',
                    format: (val, row) => this.$filters.formatDate(row.date_start)
                },
                {
                    uniqid: 'product',
                    label: 'Produtos',
                    field: 'id',
                    visible: true,
                    align: 'center',
                    classes: 'py-3 border-b',
                    headerClass: 'p-4',
                },
                {
                    uniqid: 'actions',
                    label: 'Ações',
                    field: 'id',
                    visible: true,
                    align: 'center',
                    classes: 'py-3 border-b',
                    headerClass: 'p-4',
                },
            ],
        }
    },
    methods: {
        openModalConfirmDelete(item) {
            this.$refs.modalDelete.openModalDelete(item, `/market_network_rules/${item.id}`, `Deseja realmente remover a marca ${item.brand_label}?`);
        },
        openModalEdit(item) {
            this.specialtiesOrdered = item.specialtiesOrdered;

            this.$refs.modalEdit.openModalEdit({
                id: item.id,
                provider_id: this.provider.id,
                market_network_id: this.market_network,
                market_id: this.market.id,
                brand_id: item.brand_id,
                visiting_rules_id: item.visiting_rules_id,
                priority: item.priority,
                date_start: item.date_start,
                products: item.products?.map(product => product.value),
                errors: {}
            });
        },
        reloadTable() {
            this.loadTable = false;
            setTimeout(() => this.loadTable = true, 10);
        },
        clearSearch() {
            this.search = {
                name: '',
            };
            this.reloadTable();
        },

        openModalConfig(item) {
            this.productModal = item.products,
            this.$refs.modalConfig.showModal = true;
        },

        closeModalConfig() {
            this.$refs.modalConfig.showModal = false;
        },


        saveModalConfig() {
            this.formConfig.post(`/provider_brand/products`, {
                onFinish: () => {
                    if (!Object.keys(this.formConfig.errors).length) {
                        this.closeModalConfig();
                        this.reloadTable();
                    } else {
                        this.loadModalConfig = false;
                    }
                }
            });
        },
        async loadOptions(id, mnpb) {
            await fetch(
                `/provider_brand/get-products/`+id+`/`+mnpb
            ).then(res => {
                res.json().then(json => {
                    this.productList = json.productsList;
                    this.products = json.products;
                    this.formConfig = useForm({
                        products:this.products,
                        parent_id:mnpb,
                        parent_module:'ProviderBrand',
                        //productList: [].concat(this.loadOptions(item.brand_id,item.id)),
                        productList: this.productList,
                    });
                    this.$refs.modalConfig.showModal = true;

                });
            });
        },
        async changeBrand(event) {

            await fetch(
                `/brand/get-products/` + event.target.value + `/sadasda`
            ).then(res => {
                res.json().then(json => {
                    this.specialtiesOrdered = json.productsList;
                    this.products = json.products;
                })
            })
        },
    },
}
</script>
